import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js'
import printJS from 'print-js'
import Printd from 'printd'
import download from 'downloadjs'
import Pagination from './../../shared/pagination'
import SimpleEncrypt from 'simple-encryptor'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
	name: 'ordertrackingflipkart',
	components: {
		Pagination,
		DatePicker,
		Loader,
	},
	data: function() {
		return {
			isLoading: false,
			fromDate: '',
			toDate: '',
			totalRows: 0,
			orderTrackingData: []
		}
	},
	filters: {
		moment: function(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
	},
	methods: {
		validateForm() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log("Invalid Form");
					return false;
				} else {
					this.getOrderTrackingData()
					console.log("Valid Form");
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YY-MM-DD');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		checkDateFilters() {
			var a = moment(this.dateFormat(this.fromDate), "YYYY-MM-DD");
			var b = moment(this.dateFormat(this.toDate), "YYYY-MM-DD");
			let days = moment.duration(b.diff(a)).asDays();
			if (this.fromDate && this.fromDate != '' && this.toDate && this.toDate != '' && days > 1) {
				this.fromDate = ''
				this.toDate = ''
				this.$alertify.error(this.$t('multiSellerPanel.maxDiffTwoDays'));
			}
			let today = this.dateFormat(new Date().toJSON().slice(0, 10).replace(/-/g, '/'));
			var toA = moment(today, "YYYY-MM-DD");
			var toB = moment(this.dateFormat(this.toDate), "YYYY-MM-DD");
			let diff = moment.duration(toB.diff(toA)).asDays();
			if (this.toDate && this.toDate != "" && diff > 0) {
				this.toDate = ''
				this.$alertify.error(this.$t('common.dateCannotGreaterThanCurrentErr'));
			}
		},
		getOrderTrackingData() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			this.input = ({
				"clientid": 1005,
				"fromdate": new Date(this.dateFormat1(this.fromDate)),
				"todate": new Date(this.dateFormat2(this.toDate))
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'orderTracking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.data[0].ErrorCode == 0) {
						this.orderTrackingData = result.data.data[0].data.data;
						this.totalRows = result.data.data[0].data.data.length;
					} else {
						this.orderTrackingData = [];
						this.totalRows = 0;
						this.$alertify.error(result.data.data[0].msg);
					}
				}, error => {
					console.error(error);
				});
		},
		resetFlt() {
			this.$validator.reset()
			this.fromDate = ''
			this.toDate = ''
			this.orderTrackingData = []
			this.totalRows = 0
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/reports/ordertrackingflipkart/ordertrackingflipkart.component.js